import React, { useContext } from 'react';
import ChevronRight20 from '@andes/icons/ChevronRight20';
import PropTypes from 'prop-types';
import StaticPropsContext from '../context/static-props';
import { trackEvent } from '../../lib/tracking';
import classNames from 'classnames';

const namespace = 'ui-vpp-publish-my-vehicle';
const buttonNamespace = 'button-container';
const DEFAULT_ACTION_PROPS = {
  track: {
    melidata_event: {
      type: '',
      path: '',
      event_date: {
        item_id: '',
        item_status: '',
        vertical: '',
        category_id: '',
        catalog_product_id: '',
        context: '',
      },
    },
  },
};

const PublishMyVehicleButton = ({ action = DEFAULT_ACTION_PROPS }) => {
  const {
    label: { text },
    target,
    track,
  } = action;
  const { deviceType } = useContext(StaticPropsContext);

  const HandleOnClick = e => {
    e.preventDefault();
    trackEvent(track);
    window.location.href = target;
  };

  return (
    <div className={classNames(`${namespace}--button`, deviceType)} id="publish-my-vehicle-button">
      <button type="button" className={`${buttonNamespace}__action`} onClick={HandleOnClick}>
        <span>{text}</span>
        <span className={`${buttonNamespace}__action--icon`}>
          <ChevronRight20 color="#3483FA" />
        </span>
      </button>
    </div>
  );
};

PublishMyVehicleButton.propTypes = {
  action: PropTypes.shape({
    label: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }).isRequired,
    target: PropTypes.string.isRequired,
    track: PropTypes.shape({
      melidata_event: PropTypes.shape({
        type: PropTypes.string,
        path: PropTypes.string,
        event_data: PropTypes.shape({
          item_id: PropTypes.string,
          item_status: PropTypes.string,
          vertical: PropTypes.string,
          category_id: PropTypes.string,
          catalog_product_id: PropTypes.string,
          context: PropTypes.string,
        }),
      }),
    }),
  }),
};

export default PublishMyVehicleButton;
